import * as React from 'react';
import cx from 'classnames';
import { Icon } from '@dx-ui/osc-icon';
import { Button } from '@dx-ui/global-ui-prism';

type ControlCloseButtonProps = Omit<React.ComponentProps<'button'>, 'type' | 'color'> & {
  type?: 'button' | 'submit';
};

export type ControlCloseProps = {
  /** used for screen readers and other assistive devices */
  label: string;
  /** the size of the control */
  size?: React.ComponentProps<typeof Icon>['size'];
} & ControlCloseButtonProps;

function getPrismIconSize(size: React.ComponentProps<typeof Icon>['size']) {
  switch (size) {
    case 'xs':
      return 'sm';
    case '2xl':
    case '3xl':
    case '4xl':
    case '5xl':
      return 'xl';
    default:
      return size;
  }
}

/**
 * A simple button to be used any time you need an interaction to close something. like a popup.
 */
export const ControlClose = ({
  className,
  label,
  disabled,
  size = 'md',
  ref: forwardedRef,
  ...rest
}: ControlCloseProps) => {
  const iconSize: React.ComponentProps<typeof Button>['iconProps'] = {
    name: 'close',
    size: getPrismIconSize(size),
  };

  return (
    <Button
      ref={forwardedRef}
      type="button"
      fill="flat"
      color="inherit"
      iconOnly
      label={label}
      iconProps={iconSize}
      className={cx('border-0', className)}
      disabled={disabled}
      {...rest}
    />
  );
};

export default ControlClose;
